import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {TeilpaketKraft} from '../service/Model/TeilpaketKraft';
import {UserInfo} from "../service/Model/UserInfo";
import {SelectItem, SortEvent} from "primeng/api";
import {UserData} from '../../../config/globals/userData.global';
import {MatSnackBar} from '@angular/material';
import {KraftpaketService} from '../service/kraftpaket.service';
import {CsvExport, Property2ReadableName} from '../../../config/globals/csvExport.global';
import {Vorgang} from "../service/Model/Vorgang";
import {Headers} from './types/Headers';
import {DropDownValues} from './types/DropDownValues';
import {VorgangStatus} from "./types/VorgangStatus";
import {TeilpaketStatus} from "./types/TeilpaketStatus";
import {UserRole} from "../type/UserRole";
import {Globals} from "../globals";

@Component({
  selector: 'app-datatable-kraft',
  templateUrl: './app.datatable.kraft.html',
  styleUrls: ['./app.datatable.kraft.scss']
})
export class AppDatatableKraft implements OnInit, OnDestroy {

  @Input()
  values: any[];

  @Input()
  userinfo: UserInfo;

  @Input()
  teilpaket: TeilpaketKraft;

  @Input()
  selectable: boolean = true;

  @Output()
  selectedRowEvent = new EventEmitter<any>();
  @Output()
  abbruchEvent = new EventEmitter<boolean>();
  @Output()
  checkEvent = new EventEmitter<any>();
  @Output()
  saveEvent = new EventEmitter<any>();
  @Output()
  einspielenTeilpaketEvent: EventEmitter<number> = new EventEmitter<number>();

  //Buttonsteuerung
  speichernBtAnzeigen: boolean = true;
  pruefenBtAnzeigen: boolean = true;
  einspielenBtAktiv: boolean = false;
  paketSpeichernDisabled: boolean = true;
  paketPruefenDisabled: boolean = true;
  einspielenBtAnzeigen: boolean = false;
  tableEditable: boolean = true;
  tableDataChange: boolean = false;
  columnsNotForMakler: string[];
  columnsNotForMaklerbetreuer: string[];
  columnsNotEditable: string[];
  inter: any;

  displayDialog: boolean = false;


  loadBarTimer: number = 0;
  isLoadToBiproProcess: boolean = false;

  cols: { field: string, header: string }[] = new Array<{ field: string, header: string }>();
  selectedRow: any;
  exportEnabled = true;

  statusChangeList: SelectItem[];
  statusAllList: SelectItem[];
  filterFields: any = {};

  // ILK-
  filterFelder: string[] = ["HINWEIS", "Vorgangsnummer_VM", "Name VN", "Postleitzahl VN", "Zahlungsweise",
    "Zahlungsart", "Name Halter", "Name Beitragszahler", "Beginn", "Ende", "Gewünschter Versicherungsschutz",
    "Selbstbeteiligung Teilkasko", "Selbstbeteiligung Vollkasko", "Schutzbrief", "Auslandsschadenschutz",
    "FahrerPlus-FahrerSchutz", "Rabattschutz", "AutoNotruf", "BonusDrive", "Beitragsschutz", "WerkstattBonus",
    "WerterhaltGarantie", "Eigentumsverhaeltnis zum Fahrzeug", "Fahrzeugidentifizierungsnummer",
    "Wagniskennziffer", "Amtliches Kennzeichen", "Saisonkennzeichen", "Amtliches Kennzeichen der Vorversicherung",
    "Versicherungsscheinnummer der Vorversicherung", "Produktlinie", "Anrede", "SFKlasse"
  ]

  private readonly VorgangStatus = VorgangStatus;  // need to be able use enum in corresponding html component

  constructor(private globals : Globals, private userData: UserData, private kraftpakService: KraftpaketService, private snackBar: MatSnackBar, private csvExport: CsvExport) {

  }

  ngOnInit() {
    this.filterFields = this.globals.getSpaltenFilter();

    //Spalten, die bei Maklern NICHT angezeigt werden sollen
    this.columnsNotForMakler = ['AZ Beitrag Gesamt', 'AZ Beitrag KH', 'AZ Beitrag Kasko',
      'Nachlass/Zuschlag Gesamt', 'Nachlass/Zuschlag KH', 'Nachlass/Zuschlag Kasko'];

    this.columnsNotForMaklerbetreuer = ['Nachlass/Zuschlag Gesamt', 'Nachlass/Zuschlag KH', 'Nachlass/Zuschlag Kasko'];

    this.columnsNotEditable = ['AZ Beitrag Gesamt', 'AZ Beitrag KH', 'AZ Beitrag Kasko',
      'Nachlass/Zuschlag Gesamt', 'Nachlass/Zuschlag KH', 'Nachlass/Zuschlag Kasko',
      'HINWEIS', 'Deckung KH', 'BEMERKUNG'];

    let keys = Object.keys(this.values[0]);
    console.log(keys);
    console.log(this.values[0]);
    keys.forEach((key) => {
      if ((this.userinfo.rolle == UserRole.MAKLER && this.columnsNotForMakler.includes(key)) ||
        this.userinfo.rolle == UserRole.MAKLERBETREUER && this.columnsNotForMaklerbetreuer.includes(key)) {
        //do nothing
      } else {
        this.cols.push({field: key, header: key});
      }
    });

    this.array_move(this.cols, this.cols.findIndex(col => col.header.indexOf("HINWEIS") >= 0), 1);
    // this.cols.sort((n1, n2) => n1.header.indexOf("HINWEIS")>0 ? 1 : n2.header.indexOf("HINWEIS")>0 ? -1 : 0);
    // und noch eine Spalte soll verschoben werden
    let idxVersart = this.cols.findIndex(col => col.header.indexOf("Gewünschter Versicherungsschutz") >= 0);
    this.array_move(this.cols, this.cols.findIndex(col => col.header.indexOf("Deckung KH") >= 0), idxVersart + 1);

    //Statusänderung
    this.statusChangeList = Object.values(VorgangStatus)
      .filter(status => [VorgangStatus.ZU_PRUEFEN, VorgangStatus.GESPERRT].includes(status))
      .map(val => <SelectItem>({label: val, value: val}));

    //Filter nach Status
    this.statusAllList = Object.values(VorgangStatus).map(val => <SelectItem>({label: val, value: val}));

    //Tabelle nur durch Makler bearbeitbar
    if (this.userinfo.rolle == UserRole.MAKLER) {
      this.tableEditable = true;
    }
    this.tableDataChange = false;


    //in bestimmten Status ist die Tabelle generell nicht editierbar
    // und die Buttons Speichern und prüfen werden auch nicht angezeigt
    if (this.userinfo.rolle == UserRole.PRODUKTGEBER ||
      [TeilpaketStatus.IN_FREIGABE, TeilpaketStatus.ABGELEHNT, TeilpaketStatus.EINGESPIELT, TeilpaketStatus.NICHT_EINGESPIELT,
        TeilpaketStatus.FREIGEGEBEN, TeilpaketStatus.UNGUELTIG].includes(this.teilpaket.status)) {
      this.speichernBtAnzeigen = false;
      this.pruefenBtAnzeigen = false;
      //Tabelle bearbeitbar?
      this.tableEditable = false;
    }
    //Button Prüfung nur bei neu/konvertiert oder bearbeitet, aber nur für Makler
    if ([TeilpaketStatus.NEU_KONVERTIERT, TeilpaketStatus.BEARBEITET].includes(this.teilpaket.status) &&
      [UserRole.MAKLER, UserRole.MAKLERBETREUER].includes(this.userinfo.rolle)) {
      this.paketPruefenDisabled = false;
      this.paketSpeichernDisabled = true;
      //Tabelle bearbeitbar?
      this.tableEditable = true;
    }

    if (this.userinfo.rolle == UserRole.PRODUKTGEBER) {
      this.einspielenBtAnzeigen = true;
      if (TeilpaketStatus.FREIGEGEBEN === this.teilpaket.status) {
        this.einspielenBtAktiv = true;
      }
    }

    this.inter = setInterval(() => {
      this.kraftpakService.sendIdInUse(this.teilpaket.id).subscribe((result) => {
        console.log("ping user alive: " + result);
      });
    }, 5000);
  }


  ngOnDestroy() {
    clearInterval(this.inter)
  }

  changeStatusDone(rowIndex, colIndex) {
    this.paketSpeichernDisabled = false;
    this.paketPruefenDisabled = true;
    this.tableDataChange = true;
    this.einspielenBtAktiv = false;
    //Editierte Zellen sollen farbig markiert werden
    let selectedId = rowIndex + '-' + colIndex;
    var element = document.getElementById(selectedId);
    if (element) {
      element.setAttribute("style", "background-color:yellow");
    }
  }

  array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  };

  changeDone(rowIndex, colIndex, aktvalue, value) {
    let selectedId = rowIndex + '-' + colIndex;
    if (document.getElementById(selectedId).classList.contains("ng-invalid")) {
      return;
    }
    this.paketSpeichernDisabled = false;
    this.paketPruefenDisabled = true;
    this.tableDataChange = true;
    this.einspielenBtAktiv = false;
    //Editierte Zellen sollen farbig markiert werden
    document.getElementById(selectedId).setAttribute("style", "background-color:yellow");
    aktvalue.errorMeldung = '';
    value['Status'].string = VorgangStatus.ZU_PRUEFEN;
  }

  paketdetailsSpeichern() {
    if (this.paketSpeichernDisabled == false) {
      this.saveEvent.emit(this.values);
      this.paketSpeichernDisabled = true;
      this.paketPruefenDisabled = false;
      this.displayDialog = false;
      this.tableDataChange = false;
      this.einspielenBtAktiv = true;
    }
  }

  einspielenTeilpaket() {
    if (this.einspielenBtAktiv) {
      this.einspielenTeilpaketEvent.emit(this.teilpaket.id);
    }
  }

  calculateLoadbarPossibleTime(file: any) {
    // let additionalTime = 10000;
    let calculatedTimeDependsOnFileSize = file.length * 1000 / (1.7 * this.userData.getStageMultiplicator());
    calculatedTimeDependsOnFileSize = (calculatedTimeDependsOnFileSize) / 100;
    console.log("calculatedTimeDependsOnFileSize: " + calculatedTimeDependsOnFileSize);
    let sekFormat = (file.length / 2).toString().split(".");
    console.log("loadBarTimer: " + this.loadBarTimer);
    this.snackBar.open("Der Vorgang dauert maximal: " + sekFormat[0] + " Sekunden.", null, {
      duration: calculatedTimeDependsOnFileSize + 30000,
      panelClass: ["bgc-green-400"]
    });
    let interval = setInterval(() => {
      this.loadBarTimer = this.loadBarTimer + 1;
      if (this.userData.isBiproDataLoaded()) {
        this.loadBarTimer = 100;
      }

      if (this.loadBarTimer >= 100) {
        this.isLoadToBiproProcess = false;
        this.userData.setBiproDataLoaded(false)
        this.loadBarTimer = 0;
        this.snackBar.open("Daten werden vorbereitet, warten Sie noch ganz kurz!", null, {
          duration: 8000,
          panelClass: ["bgc-green-400"]
        });
        clearInterval(interval);
      }
    }, calculatedTimeDependsOnFileSize);
  }

  paketdeailsPruefen() {
    if (this.paketPruefenDisabled == false) {
      if (this.hasDoppelteKennzeichen() == true) {
        console.log("Doppeltes Kennzeichen!!!")
        return;
      }
      this.isLoadToBiproProcess = true;
      console.log("isLoadToBiproProcess: " + this.isLoadToBiproProcess);
      this.calculateLoadbarPossibleTime(this.values);
      this.checkEvent.emit(this.values);
      this.paketSpeichernDisabled = true;
      this.paketPruefenDisabled = true;
      this.displayDialog = false;
      this.tableDataChange = false;
    }
  }

  private hasDoppelteKennzeichen(): boolean {
    let result: boolean = false;
    let meldung: string = "FAHRZEUG: Das Kennzeichen ist in dieser Datei bereits vorhanden. Bitte korrigieren.";
    for (var i: number = 0; i < this.values.length; i++) {
      // vor der eigentlichen Prüfung Hinweis/Status zurücksetzen
      //this.values[i]["HINWEIS"].string = "";
      //this.values[i]["Status"].string = VorgangStatus.OK

      var currentPlate = this.values[i]["Amtliches Kennzeichen"].string;
      var currentStatus = this.values[i]["Status"].string;

      // Kann man den Status ignorieren?
      if (this.statusMustBeChecked(currentStatus) == true) {
        for (var j: number = i + 1; j < this.values.length; j++) {
          var tmpPlate = this.values[j]["Amtliches Kennzeichen"].string;
          var tmpStatus = this.values[j]["Status"].string;
          // Kann man den Status ignorieren?
          if (this.statusMustBeChecked(tmpStatus) == true) {
            // Kennzeichen gleich???
            if (currentPlate == tmpPlate) {
              result = true;
              this.values[i]["HINWEIS"].string = meldung + " (" + currentPlate + ")";
              this.values[j]["HINWEIS"].string = meldung + " (" + currentPlate + ")";
              this.values[i]["Status"].string = VorgangStatus.NICHT_OK;
              this.values[j]["Status"].string = VorgangStatus.NICHT_OK;
              this.values[i]["Amtliches Kennzeichen"].errorMeldung = meldung;
              this.values[j]["Amtliches Kennzeichen"].errorMeldung = meldung;
            }
          }
        }
      }
    }
    return result;
  }

  private statusMustBeChecked(status: string): boolean {
    if (status == VorgangStatus.GESPERRT) return false;
    if (status == VorgangStatus.GESPERRT_DURCH_PG) return false;

    return true;
  }

  paketdeailsAbbruch() {
    if (this.tableDataChange == true) {
      this.displayDialog = true;
    } else {
      this.abbruchEvent.emit(true);
    }
  }

  paketdeailsSchliessen() {
    this.displayDialog = false;
    this.abbruchEvent.emit(true);
  }

  longestValueOfCol(colName: string): number {
    let longest = -1;
    this.values.forEach(value => {
      let length = value[colName].string.length;
      longest = length > longest ? length : longest;
    });
    //let lengthHeader = colName.length;
    //(lengthHeader > longest) ? longest = lengthHeader : longest = longest;

    //return longest;
    return longest > 100 ? 100 : longest;
  }

  trackTeilpaketeTabelle(index: number, item: TeilpaketKraft): number {
    return item.id;
  }

  getColorOfIcon(status: string): string {
    switch (status) {
      case VorgangStatus.NICHT_OK:
        return "red";
      case VorgangStatus.OK:
        return "forestgreen";
      case VorgangStatus.GESPERRT:
        return "#0072c0";
      default:
        return "grey";
    }
  }

  tableColumnEditable(columnName: string): boolean {

    return !(this.columnsNotEditable.includes(columnName));
  }

  isCellStatusEditable(rowIndex: number): boolean {
    switch (this.userinfo.rolle) {
      case UserRole.PRODUKTGEBER:
        if (VorgangStatus.GESPERRT_DURCH_PG == this.values[rowIndex]['Status'].string ||
          TeilpaketStatus.IN_FREIGABE == this.teilpaket.status) {
          return true;
        }
        return false;
      default:
        if (VorgangStatus.GESPERRT_DURCH_PG == this.values[rowIndex]['Status'].string) {
          return false;
        }
        return true;
    }
  }

  dateReplacer(value: string): string {
    return value.indexOf("/") > 0 ? value.replace("/", ".").replace("/", ".") :
      value;
  }

  private isThisNum(value: string, header: string): boolean {
    return (header.indexOf("AZ Beitrag") >= 0 || header.indexOf("Beitrag VorVU ") >= 0)
      && (value != null) && !isNaN(Number(value));
  }

  getStatusChangeList(aktuellerStatus: string): SelectItem[] {
    //Statusänderung
    this.statusChangeList = [];
    this.add2StatusChangeListIfNotIncluded(<SelectItem>{label: aktuellerStatus, value: aktuellerStatus});

    if (UserRole.PRODUKTGEBER == this.userinfo.rolle) {
      this.add2StatusChangeListIfNotIncluded(<SelectItem>{label: VorgangStatus.OK, value: VorgangStatus.OK});
      if (TeilpaketStatus.IN_FREIGABE == this.teilpaket.status) {
        this.add2StatusChangeListIfNotIncluded(<SelectItem>{
          label: VorgangStatus.GESPERRT_DURCH_PG,
          value: VorgangStatus.GESPERRT_DURCH_PG
        })
      }
    } else {
      this.add2StatusChangeListIfNotIncluded(<SelectItem>{
        label: VorgangStatus.GESPERRT,
        value: VorgangStatus.GESPERRT
      });
      this.add2StatusChangeListIfNotIncluded(<SelectItem>{
        label: VorgangStatus.ZU_PRUEFEN,
        value: VorgangStatus.ZU_PRUEFEN
      });
    }

    return this.statusChangeList;
  }

  private add2StatusChangeListIfNotIncluded(newItem: SelectItem) {
    if (!this.statusChangeList.find(status => status.value === newItem.value && status.label === newItem.label)) {
      this.statusChangeList.push(newItem);
    }
  }

  getGeneralizedChangeList(index: any): SelectItem[] {
    //Statusänderung
    this.statusChangeList = [];

    // if(index==0){
    // if (!aktuellerStatus.includes('gesperrt') && !aktuellerStatus.includes('zu prüfen')) {
    //   this.statusChangeList.push({label: aktuellerStatus, value: aktuellerStatus});
    // }
    //   this.statusChangeList.push({label: 'gesperrt', value: 'gesperrt'});
    //   this.statusChangeList.push({label: 'zu prüfen', value: 'zu prüfen'});
    // }
    if (index == 14) {
      this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
      this.statusChangeList.push({label: DropDownValues.LASTSCHRIFT, value: DropDownValues.LASTSCHRIFT});
      this.statusChangeList.push({label: DropDownValues.RECHNUNG, value: DropDownValues.RECHNUNG});
    }
    if (index == 39) {
      this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
      this.statusChangeList.push({label: DropDownValues.HAFTPFLICHT, value: DropDownValues.HAFTPFLICHT});
      this.statusChangeList.push({label: DropDownValues.VOLLKASKO, value: DropDownValues.VOLLKASKO});
      this.statusChangeList.push({label: DropDownValues.TEILKASKO, value: DropDownValues.TEILKASKO});
    }

    if (index == 54) {
      this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
      this.statusChangeList.push({label: DropDownValues.EIGENTUM_VN, value: DropDownValues.EIGENTUM_VN});
      this.statusChangeList.push({label: DropDownValues.FINANZIERUNG, value: DropDownValues.FINANZIERUNG});
      this.statusChangeList.push({label: DropDownValues.LEASING, value: DropDownValues.LEASING});
    }

    if (index == 75) {
      this.statusChangeList.push({label: DropDownValues.SMART, value: DropDownValues.SMART});
      this.statusChangeList.push({label: DropDownValues.KOMFORT, value: DropDownValues.KOMFORT});
      this.statusChangeList.push({label: DropDownValues.PREMIUM, value: DropDownValues.PREMIUM});
    }

    if (index == 13) {
      this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
      this.statusChangeList.push({label: DropDownValues.MONATLICH, value: DropDownValues.MONATLICH});
      this.statusChangeList.push({label: DropDownValues.VIERTELJAEHRLICH, value: DropDownValues.VIERTELJAEHRLICH});
      this.statusChangeList.push({label: DropDownValues.HALBJAEHRLICH, value: DropDownValues.HALBJAEHRLICH});
      this.statusChangeList.push({label: DropDownValues.JAEHRLICH, value: DropDownValues.JAEHRLICH});
    }

    // Teilkasko
    // ILK-2422: TK-SB -> 0,150,300,500
    if (index == 42) {
      this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
      this.statusChangeList.push({label: DropDownValues.NUM_0, value: DropDownValues.NUM_0});
      this.statusChangeList.push({label: DropDownValues.NUM_150, value: DropDownValues.NUM_150});
      this.statusChangeList.push({label: DropDownValues.NUM_300, value: DropDownValues.NUM_300});
      this.statusChangeList.push({label: DropDownValues.NUM_500, value: DropDownValues.NUM_500});
    }

    // Vollkasko
    // ILK-2422: VK-SB -> 0,150,300,500,1000
    // ILK-2587: Entfernen von SB 0,150
    if (index == 44) {
      this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
//      this.statusChangeList.push({label: DropDownValues.NUM_0, value: DropDownValues.NUM_0});
//      this.statusChangeList.push({label: DropDownValues.NUM_150, value: DropDownValues.NUM_150});
      this.statusChangeList.push({label: DropDownValues.NUM_300, value: DropDownValues.NUM_300});
      this.statusChangeList.push({label: DropDownValues.NUM_500, value: DropDownValues.NUM_500});
      this.statusChangeList.push({label: DropDownValues.NUM_1000, value: DropDownValues.NUM_1000});
    }

    if (index == 45 || index == 46 || index == 47 || index == 48 || index == 49 || index == 50 || index == 51 || index == 52 || index == 53) {
      this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
      this.statusChangeList.push({label: DropDownValues.JA, value: DropDownValues.JA});
    }
    if (index == 43 || index == 41) {
      this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
      this.statusChangeList.push({label: DropDownValues.SF_M, value: DropDownValues.SF_M});
      this.statusChangeList.push({label: DropDownValues.SF_0, value: DropDownValues.SF_0});
      this.statusChangeList.push({label: DropDownValues.SF_S, value: DropDownValues.SF_S});
      this.statusChangeList.push({label: DropDownValues.SF_1_2, value: DropDownValues.SF_1_2});
      this.statusChangeList.push({label: DropDownValues.SF_1, value: DropDownValues.SF_1});
      this.statusChangeList.push({label: DropDownValues.SF_2, value: DropDownValues.SF_2});
      this.statusChangeList.push({label: DropDownValues.SF_3, value: DropDownValues.SF_3});
      this.statusChangeList.push({label: DropDownValues.SF_4, value: DropDownValues.SF_4});
      this.statusChangeList.push({label: DropDownValues.SF_5, value: DropDownValues.SF_5});
      this.statusChangeList.push({label: DropDownValues.SF_6, value: DropDownValues.SF_6});
      this.statusChangeList.push({label: DropDownValues.SF_7, value: DropDownValues.SF_7});
      this.statusChangeList.push({label: DropDownValues.SF_8, value: DropDownValues.SF_8});
      this.statusChangeList.push({label: DropDownValues.SF_9, value: DropDownValues.SF_9});
      this.statusChangeList.push({label: DropDownValues.SF_10, value: DropDownValues.SF_10});
      this.statusChangeList.push({label: DropDownValues.SF_11, value: DropDownValues.SF_11});
      this.statusChangeList.push({label: DropDownValues.SF_12, value: DropDownValues.SF_12});
      this.statusChangeList.push({label: DropDownValues.SF_13, value: DropDownValues.SF_13});
      this.statusChangeList.push({label: DropDownValues.SF_14, value: DropDownValues.SF_14});
      this.statusChangeList.push({label: DropDownValues.SF_15, value: DropDownValues.SF_15});
      this.statusChangeList.push({label: DropDownValues.SF_16, value: DropDownValues.SF_16});
      this.statusChangeList.push({label: DropDownValues.SF_17, value: DropDownValues.SF_17});
      this.statusChangeList.push({label: DropDownValues.SF_18, value: DropDownValues.SF_18});
      this.statusChangeList.push({label: DropDownValues.SF_19, value: DropDownValues.SF_19});
      this.statusChangeList.push({label: DropDownValues.SF_20, value: DropDownValues.SF_20});
      this.statusChangeList.push({label: DropDownValues.SF_21, value: DropDownValues.SF_21});
      this.statusChangeList.push({label: DropDownValues.SF_22, value: DropDownValues.SF_22});
      this.statusChangeList.push({label: DropDownValues.SF_23, value: DropDownValues.SF_23});
      this.statusChangeList.push({label: DropDownValues.SF_24, value: DropDownValues.SF_24});
      this.statusChangeList.push({label: DropDownValues.SF_25, value: DropDownValues.SF_25});
      this.statusChangeList.push({label: DropDownValues.SF_26, value: DropDownValues.SF_26});
      this.statusChangeList.push({label: DropDownValues.SF_27, value: DropDownValues.SF_27});
      this.statusChangeList.push({label: DropDownValues.SF_28, value: DropDownValues.SF_28});
      this.statusChangeList.push({label: DropDownValues.SF_29, value: DropDownValues.SF_29});
      this.statusChangeList.push({label: DropDownValues.SF_30, value: DropDownValues.SF_30});
      this.statusChangeList.push({label: DropDownValues.SF_31, value: DropDownValues.SF_31});
      this.statusChangeList.push({label: DropDownValues.SF_32, value: DropDownValues.SF_32});
      this.statusChangeList.push({label: DropDownValues.SF_33, value: DropDownValues.SF_33});
      this.statusChangeList.push({label: DropDownValues.SF_34, value: DropDownValues.SF_34});
      this.statusChangeList.push({label: DropDownValues.SF_35, value: DropDownValues.SF_35});
      this.statusChangeList.push({label: DropDownValues.SF_36, value: DropDownValues.SF_36});
      this.statusChangeList.push({label: DropDownValues.SF_37, value: DropDownValues.SF_37});
      this.statusChangeList.push({label: DropDownValues.SF_38, value: DropDownValues.SF_38});
      this.statusChangeList.push({label: DropDownValues.SF_39, value: DropDownValues.SF_39});
      this.statusChangeList.push({label: DropDownValues.SF_40, value: DropDownValues.SF_40});
      this.statusChangeList.push({label: DropDownValues.SF_41, value: DropDownValues.SF_41});
      this.statusChangeList.push({label: DropDownValues.SF_42, value: DropDownValues.SF_42});
      this.statusChangeList.push({label: DropDownValues.SF_43, value: DropDownValues.SF_43});
      this.statusChangeList.push({label: DropDownValues.SF_44, value: DropDownValues.SF_44});
      this.statusChangeList.push({label: DropDownValues.SF_45, value: DropDownValues.SF_45});
      this.statusChangeList.push({label: DropDownValues.SF_46, value: DropDownValues.SF_46});
      this.statusChangeList.push({label: DropDownValues.SF_47, value: DropDownValues.SF_47});
      this.statusChangeList.push({label: DropDownValues.SF_48, value: DropDownValues.SF_48});
      this.statusChangeList.push({label: DropDownValues.SF_49, value: DropDownValues.SF_49});
      this.statusChangeList.push({label: DropDownValues.SF_50, value: DropDownValues.SF_50});
    }

    if (this.teilpaket.dateiname.indexOf(".xls") > -1 || this.teilpaket.dateiname.indexOf(".xlsx") > -1) {
      if (index == 3 || index == 20 || index == 29) {
        this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
        this.statusChangeList.push({label: DropDownValues.HERR, value: DropDownValues.HERR});
        this.statusChangeList.push({label: DropDownValues.FRAU, value: DropDownValues.FRAU});
        this.statusChangeList.push({label: DropDownValues.FIRMA, value: DropDownValues.FIRMA});
      }
      if (index == 18 || index == 28) {
        this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
        this.statusChangeList.push({label: DropDownValues.GBR, value: DropDownValues.GBR});
        this.statusChangeList.push({label: DropDownValues.OHG, value: DropDownValues.OHG});
        this.statusChangeList.push({label: DropDownValues.KG, value: DropDownValues.KG});
        this.statusChangeList.push({label: DropDownValues.GMBH, value: DropDownValues.GMBH});
        this.statusChangeList.push({label: DropDownValues.GGMBH, value: DropDownValues.GGMBH});
        this.statusChangeList.push({label: DropDownValues.GMBH_CO_KG, value: DropDownValues.GMBH_CO_KG});
        this.statusChangeList.push({label: DropDownValues.KGAA, value: DropDownValues.KGAA});
        this.statusChangeList.push({label: DropDownValues.VEREIN_NACH_BGB, value: DropDownValues.VEREIN_NACH_BGB});
        this.statusChangeList.push({label: DropDownValues.EG, value: DropDownValues.EG});
        this.statusChangeList.push({label: DropDownValues.GAG, value: DropDownValues.GAG});
        this.statusChangeList.push({label: DropDownValues.PARTG, value: DropDownValues.PARTG});
        this.statusChangeList.push({label: DropDownValues.PARTNERREEDEREI, value: DropDownValues.PARTNERREEDEREI});
        this.statusChangeList.push({label: DropDownValues.GMBHUNDCOKGAA, value: DropDownValues.GMBHUNDCOKGAA});
        this.statusChangeList.push({label: DropDownValues.AGCOKGAA, value: DropDownValues.AGCOKGAA});
        this.statusChangeList.push({label: DropDownValues.LTD, value: DropDownValues.LTD});
        this.statusChangeList.push({label: DropDownValues.AG, value: DropDownValues.AG});
        this.statusChangeList.push({label: DropDownValues.EV, value: DropDownValues.EV});
        this.statusChangeList.push({label: DropDownValues.KDOER, value: DropDownValues.KDOER});
        this.statusChangeList.push({
          label: DropDownValues.STIFTUNGDESOEFFENTLICHENRECHTS,
          value: DropDownValues.STIFTUNGDESOEFFENTLICHENRECHTS
        });
        this.statusChangeList.push({label: DropDownValues.ZWECKVERBAND, value: DropDownValues.ZWECKVERBAND});
        this.statusChangeList.push({label: DropDownValues.GEWERKSCHAFT, value: DropDownValues.GEWERKSCHAFT});
        this.statusChangeList.push({label: DropDownValues.SONSTIGE, value: DropDownValues.SONSTIGE});
      }
      if (index == 15 || index == 17 || index == 19 || index == 62 || index == 65 || index == 73) {
        this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
        this.statusChangeList.push({label: DropDownValues.JA, value: DropDownValues.JA});
        this.statusChangeList.push({label: DropDownValues.NEIN, value: DropDownValues.NEIN});
      }

    } else {
      if (index == 3 || index == 21 || index == 29) {
        this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
        this.statusChangeList.push({label: DropDownValues.HERR, value: DropDownValues.HERR});
        this.statusChangeList.push({label: DropDownValues.FRAU, value: DropDownValues.FRAU});
        this.statusChangeList.push({label: DropDownValues.FIRMA, value: DropDownValues.FIRMA});
      }
      if (index == 18 || index == 19) {
        this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
        this.statusChangeList.push({label: DropDownValues.GBR, value: DropDownValues.GBR});
        this.statusChangeList.push({label: DropDownValues.OHG, value: DropDownValues.OHG});
        this.statusChangeList.push({label: DropDownValues.KG, value: DropDownValues.KG});
        this.statusChangeList.push({label: DropDownValues.GMBH, value: DropDownValues.GMBH});
        this.statusChangeList.push({label: DropDownValues.GGMBH, value: DropDownValues.GGMBH});
        this.statusChangeList.push({label: DropDownValues.GMBH_CO_KG, value: DropDownValues.GMBH_CO_KG});
        this.statusChangeList.push({label: DropDownValues.KGAA, value: DropDownValues.KGAA});
        this.statusChangeList.push({label: DropDownValues.VEREIN_NACH_BGB, value: DropDownValues.VEREIN_NACH_BGB});
        this.statusChangeList.push({label: DropDownValues.EG, value: DropDownValues.EG});
        this.statusChangeList.push({label: DropDownValues.GAG, value: DropDownValues.GAG});
        this.statusChangeList.push({label: DropDownValues.PARTG, value: DropDownValues.PARTG});
        this.statusChangeList.push({label: DropDownValues.PARTNERREEDEREI, value: DropDownValues.PARTNERREEDEREI});
        this.statusChangeList.push({label: DropDownValues.GMBHUNDCOKGAA, value: DropDownValues.GMBHUNDCOKGAA});
        this.statusChangeList.push({label: DropDownValues.AGCOKGAA, value: DropDownValues.AGCOKGAA});
        this.statusChangeList.push({label: DropDownValues.LTD, value: DropDownValues.LTD});
        this.statusChangeList.push({label: DropDownValues.AG, value: DropDownValues.AG});
        this.statusChangeList.push({label: DropDownValues.EV, value: DropDownValues.EV});
        this.statusChangeList.push({label: DropDownValues.KDOER, value: DropDownValues.KDOER});
        this.statusChangeList.push({
          label: DropDownValues.STIFTUNGDESOEFFENTLICHENRECHTS,
          value: DropDownValues.STIFTUNGDESOEFFENTLICHENRECHTS
        });
        this.statusChangeList.push({label: DropDownValues.ZWECKVERBAND, value: DropDownValues.ZWECKVERBAND});
        this.statusChangeList.push({label: DropDownValues.GEWERKSCHAFT, value: DropDownValues.GEWERKSCHAFT});
        this.statusChangeList.push({label: DropDownValues.SONSTIGE, value: DropDownValues.SONSTIGE});
      }

      if (index == 15 || index == 17 || index == 20 || index == 62 || index == 65 || index == 73) {
        this.statusChangeList.push({label: DropDownValues.EMPTY, value: DropDownValues.EMPTY});
        this.statusChangeList.push({label: DropDownValues.JA, value: DropDownValues.JA});
        this.statusChangeList.push({label: DropDownValues.NEIN, value: DropDownValues.NEIN});
      }
    }
    return this.statusChangeList;
  }

  checkNotMultipleFieldsIndexes(index: any) {
    if (this.teilpaket.dateiname.indexOf(".xls") > -1 || this.teilpaket.dateiname.indexOf(".xlsx") > -1) {
      return (index == 0 || index == 3 || index == 20 || index == 29 || index == 13 || index == 39 || index == 42 || index == 44 || index == 54 || index == 75
        || index == 15 || index == 17 || index == 19 || index == 62 || index == 65 || index == 73 || index == 18 || index == 28 || index == 41 || index == 43
        || index == 45 || index == 46 || index == 47 || index == 48 || index == 49 || index == 50 || index == 51 || index == 52 || index == 53 || index == 14) ? false : true;
    } else if (this.teilpaket.dateiname.indexOf(".gdv") > -1 || this.teilpaket.dateiname.indexOf(".GDV") > -1 || this.teilpaket.dateiname.indexOf(".DAV") > -1) {
      return (index == 0 || index == 3 || index == 21 || index == 29 || index == 13 || index == 39 || index == 42 || index == 44 || index == 54 || index == 75
        || index == 15 || index == 17 || index == 19 || index == 62 || index == 65 || index == 73 || index == 18 || index == 20 || index == 41 || index == 43
        || index == 45 || index == 46 || index == 47 || index == 48 || index == 49 || index == 50 || index == 51 || index == 52 || index == 53 || index == 14) ? false : true;
    } else {
      return true;
    }
  }

  getFiledDependsOnIndex(index: any): string {
    //ToDo depends on Datei xlsx oder gdv
    if (this.teilpaket.dateiname.indexOf(".xls") > -1 || this.teilpaket.dateiname.indexOf(".xlsx") > -1) {
      if (index == 3) {
        return Headers.ANREDE_VN;
      }
      if (index == 20) {
        return Headers.ANREDE_HALTER;
      }
      if (index == 29) {
        return Headers.ANREDE_BEITRAGSZAHLER;
      }
      if (index == 28) {
        return Headers.RECHTSFORM_HALTER;
      }
      if (index == 13) {
        return Headers.ZAHLUNGSWEISE;
      }
      if (index == 14) {
        return Headers.ZAHLUNGSART;
      }
      if (index == 39) {
        return Headers.GEWÜNSCHTER_VERSICHERUNGSSCHUTZ;
      }
      if (index == 42) {
        return Headers.SELBSTBETEILIGUNG_TEILKASKO;
      }
      if (index == 41) {
        return Headers.SFKLASSE_HAFTPFLICHT;
      }
      if (index == 43) {
        return Headers.SFKLASSE_VOLLKASKO;
      }
      if (index == 44) {
        return Headers.SELBSTBETEILIGUNG_VOLLKASKO;
      }
      if (index == 54) {
        return Headers.EIGENTUMSVERHAELTNIS_ZUM_FAHRZEUG;
      }
      if (index == 75) {
        return Headers.PRODUKTLINIE;
      }
      if (index == 15) {
        return Headers.ABWEICHENDER_BEITRAGSZAHLER;
      }
      if (index == 19) {
        return Headers.ABWEICHENDER_HALTER;
      }
      if (index == 18) {
        return Headers.RECHTSFORM_VN;
      }
      if (index == 17) {
        return Headers.VORSTEUERABZUGSBERECHTIGUNG_VN;
      }
      if (index == 62) {
        return Headers.SAISONKENNZEICHEN;
      }
      if (index == 73) {
        return Headers.SAISONKENNZEICHEN_DER_VORVERSICHERUNG;
      }
      if (index == 65) {
        return Headers.BETRIEBSAUSGABE;
      }
      if (index == 45) {
        return Headers.SCHUTZBRIEF;
      }
      if (index == 46) {
        return Headers.AUSLANDSSCHADENSCHUTZ;
      }
      if (index == 47) {
        return Headers.FAHRERPLUS_FAHRERSCHUTZ;
      }
      if (index == 48) {
        return Headers.RABATTSCHUTZ;
      }
      if (index == 49) {
        return Headers.AUTONOTRUF;
      }
      if (index == 50) {
        return Headers.BONUSDRIVE;
      }
      if (index == 51) {
        return Headers.BEITRAGSSCHUTZ;
      }
      if (index == 52) {
        return Headers.WERKSTATTBONUS;
      }
      if (index == 53) {
        return Headers.WERTERHALTGARANTIE;
      }
    } else {
      if (index == 3) {
        return Headers.ANREDE_VN;
      }
      if (index == 29) {
        return Headers.ANREDE_HALTER;
      }
      if (index == 21) {
        return Headers.ANREDE_BEITRAGSZAHLER;
      }
      if (index == 19) {
        return Headers.RECHTSFORM_HALTER;
      }
      if (index == 13) {
        return Headers.ZAHLUNGSWEISE;
      }
      if (index == 14) {
        return Headers.ZAHLUNGSART;
      }
      if (index == 39) {
        return Headers.GEWÜNSCHTER_VERSICHERUNGSSCHUTZ;
      }
      if (index == 42) {
        return Headers.SELBSTBETEILIGUNG_TEILKASKO;
      }
      if (index == 41) {
        return Headers.SFKLASSE_HAFTPFLICHT;
      }
      if (index == 43) {
        return Headers.SFKLASSE_VOLLKASKO;
      }
      if (index == 44) {
        return Headers.SELBSTBETEILIGUNG_VOLLKASKO;
      }
      if (index == 54) {
        return Headers.EIGENTUMSVERHAELTNIS_ZUM_FAHRZEUG;
      }
      if (index == 75) {
        return Headers.PRODUKTLINIE;
      }
      if (index == 15) {
        return Headers.ABWEICHENDER_BEITRAGSZAHLER;
      }
      if (index == 20) {
        return Headers.ABWEICHENDER_HALTER;
      }
      if (index == 18) {
        return Headers.RECHTSFORM_VN;
      }
      if (index == 17) {
        return Headers.VORSTEUERABZUGSBERECHTIGUNG_VN;
      }
      if (index == 62) {
        return Headers.SAISONKENNZEICHEN;
      }
      if (index == 73) {
        return Headers.SAISONKENNZEICHEN_DER_VORVERSICHERUNG;
      }
      if (index == 65) {
        return Headers.BETRIEBSAUSGABE;
      }
      if (index == 45) {
        return Headers.SCHUTZBRIEF;
      }
      if (index == 46) {
        return Headers.AUSLANDSSCHADENSCHUTZ;
      }
      if (index == 47) {
        return Headers.FAHRERPLUS_FAHRERSCHUTZ;
      }
      if (index == 48) {
        return Headers.RABATTSCHUTZ;
      }
      if (index == 49) {
        return Headers.AUTONOTRUF;
      }
      if (index == 50) {
        return Headers.BONUSDRIVE;
      }
      if (index == 51) {
        return Headers.BEITRAGSSCHUTZ;
      }
      if (index == 52) {
        return Headers.WERKSTATTBONUS;
      }
      if (index == 53) {
        return Headers.WERTERHALTGARANTIE;
      }
    }
  }

  exportCSV(columns2UseOnly: any[], inputData: any[], teilpaketFileName: string) {
    let exportFileName = teilpaketFileName.split('.').slice(0, -1) + '.csv';
    let propertyNames2Use = this.chooseColumnMappingRestrictedTo(columns2UseOnly, this.userinfo.rolle);
    let inputAsVorgang = this.convertData2ObjectForm(inputData);

    this.csvExport.downloadAsCSV(inputAsVorgang, propertyNames2Use, exportFileName);
  }

  // used for export functionality
  private static dataMapping2Object: Property2ReadableName[] = [
    {propertyName: "status", readableName: "Status"},
    {propertyName: "hinweis", readableName: "HINWEIS"},
    {propertyName: "vorgangsnummerVM", readableName: "Vorgangsnummer_VM"},
    {propertyName: "anredeVN", readableName: "Anrede VN"},
    {propertyName: "nameVN", readableName: "Name VN"},
    {propertyName: "vornameVN", readableName: "Vorname VN"},
    {propertyName: "geburtsdatumVN", readableName: "Geburtsdatum VN"},
    {propertyName: "postleitzahlVN", readableName: "Postleitzahl VN"},
    {propertyName: "wohnortVN", readableName: "Wohnort VN"},
    {propertyName: "strasseVN", readableName: "Strasse VN"},
    {propertyName: "hausnummerVN", readableName: "Hausnummer VN"},
    {propertyName: "eMailVN", readableName: "E-Mail VN"},
    {propertyName: "telefonVN", readableName: "Telefon VN"},
    {propertyName: "zahlungsweise", readableName: "Zahlungsweise"},
    {propertyName: "zahlungsart", readableName: "Zahlungsart"},
    {propertyName: "abweichenderBeitragszahler", readableName: "Abweichender Beitragszahler"},
    {propertyName: "bankverbindungIBAN", readableName: "Bankverbindung IBAN"},
    {propertyName: "vorsteuerabzugsberechtigungVN", readableName: "Vorsteuerabzugsberechtigung VN"},
    {propertyName: "rechtsformVN", readableName: "Rechtsform VN"},
    {propertyName: "abweichenderHalter", readableName: "Abweichender Halter"},
    {propertyName: "anredeHalter", readableName: "Anrede Halter"},
    {propertyName: "nameHalter", readableName: "Name Halter"},
    {propertyName: "vornameHalter", readableName: "Vorname Halter"},
    {propertyName: "geburtsdatumHalter", readableName: "Geburtsdatum Halter"},
    {propertyName: "postleitzahlHalter", readableName: "Postleitzahl Halter"},
    {propertyName: "wohnortHalter", readableName: "Wohnort Halter"},
    {propertyName: "strasseHalter", readableName: "Strasse Halter"},
    {propertyName: "hausnummerHalter", readableName: "Hausnummer Halter"},
    {propertyName: "rechtsformHalter", readableName: "Rechtsform Halter"},
    {propertyName: "anredeBeitragszahler", readableName: "Anrede Beitragszahler"},
    {propertyName: "nameBeitragszahler", readableName: "Name Beitragszahler"},
    {propertyName: "vornameBeitragszahler", readableName: "Vorname Beitragszahler"},
    {propertyName: "geburtsdatumBeitragszahler", readableName: "Geburtsdatum Beitragszahler"},
    {propertyName: "postleitzahlBeitragszahler", readableName: "Postleitzahl Beitragszahler"},
    {propertyName: "ortBeitragszahler", readableName: "Ort Beitragszahler"},
    {propertyName: "strasseBeitragszahler", readableName: "Strasse Beitragszahler"},
    {propertyName: "hausnummerBeitragszahler", readableName: "Hausnummer Beitragszahler"},
    {propertyName: "beginn", readableName: "Beginn"},
    {propertyName: "ende", readableName: "Ende"},
    {propertyName: "gewuenschterVersicherungsschutz", readableName: "Gewünschter Versicherungsschutz"},
    {propertyName: "deckungKH", readableName: "Deckung KH"},
    {propertyName: "sFKlasseHaftpflicht", readableName: "SFKlasse Haftpflicht"},
    {propertyName: "selbstbeteiligungTeilkasko", readableName: "Selbstbeteiligung Teilkasko"},
    {propertyName: "sFKlasseVollkasko", readableName: "SFKlasse Vollkasko"},
    {propertyName: "selbstbeteiligungVollkasko", readableName: "Selbstbeteiligung Vollkasko"},
    {propertyName: "schutzbrief", readableName: "Schutzbrief"},
    {propertyName: "auslandsschadenschutz", readableName: "Auslandsschadenschutz"},
    {propertyName: "fahrerPlusFahrerSchutz", readableName: "FahrerPlus-FahrerSchutz"},
    {propertyName: "rabattschutz", readableName: "Rabattschutz"},
    {propertyName: "autoNotruf", readableName: "AutoNotruf"},
    {propertyName: "bonusDrive", readableName: "BonusDrive"},
    {propertyName: "beitragsschutz", readableName: "Beitragsschutz"},
    {propertyName: "werkstattBonus", readableName: "WerkstattBonus"},
    {propertyName: "werterhaltGarantie", readableName: "WerterhaltGarantie"},
    {propertyName: "eigentumsverhaeltnisFahrzeug", readableName: "Eigentumsverhaeltnis zum Fahrzeug"},
    {propertyName: "erstzulassungFahrzeuges", readableName: "Erstzulassung des Fahrzeuges"},
    {propertyName: "ersteZulassungVNHalter", readableName: "Erste Zulassung auf den VN / Halter"},
    {propertyName: "fahrzeugidentifizierungsnummer", readableName: "Fahrzeugidentifizierungsnummer"},
    {propertyName: "herstellerschluessel", readableName: "Herstellerschluessel"},
    {propertyName: "typschluessel", readableName: "Typschluessel"},
    {propertyName: "wagniskennziffer", readableName: "Wagniskennziffer"},
    {propertyName: "amtlichesKennzeichen", readableName: "Amtliches Kennzeichen"},
    {propertyName: "saisonkennzeichen", readableName: "Saisonkennzeichen"},
    {propertyName: "betriebszeitraumVon", readableName: "Betriebszeitraum von (Monat)"},
    {propertyName: "betriebszeitraumBis", readableName: "Betriebszeitraum bis (Monat)"},
    {propertyName: "betriebsausgabe", readableName: "Betriebsausgabe"},
    {propertyName: "beitragVorVUGesamt", readableName: "Beitrag VorVU Gesamt"},
    {propertyName: "beitragVorVUKH", readableName: "Beitrag VorVU KH"},
    {propertyName: "beitragVorVUKasko", readableName: "Beitrag VorVU Kasko"},
    {propertyName: "beitragVorVUSonstiges", readableName: "Beitrag VorVU Sonstiges"},
    {propertyName: "beitragVorVUInsassenUnfall", readableName: "Beitrag VorVU Insassen-Unfall"},
    {propertyName: "vorVUNrGDVNr", readableName: "VorVU-Nr. (GDV-Nr.)"},
    {propertyName: "amtlichesKennzeichenVorversicherung", readableName: "Amtliches Kennzeichen der Vorversicherung"},
    {propertyName: "saisonkennzeichenVorversicherung", readableName: "Saisonkennzeichen der Vorversicherung"},
    {
      propertyName: "versicherungsscheinnummerVorversicherung",
      readableName: "Versicherungsscheinnummer der Vorversicherung"
    },
    {propertyName: "produktlinie", readableName: "Produktlinie"},
    {propertyName: "aZBeitragGesamt", readableName: "AZ Beitrag Gesamt"},
    {propertyName: "aZBeitragKH", readableName: "AZ Beitrag KH"},
    {propertyName: "aZBeitragKasko", readableName: "AZ Beitrag Kasko"},
    {propertyName: "nachlassZuschlagGesamt", readableName: "Nachlass/Zuschlag Gesamt"},
    {propertyName: "nachlassZuschlagKH", readableName: "Nachlass/Zuschlag KH"},
    {propertyName: "nachlassZuschlagKasko", readableName: "Nachlass/Zuschlag Kasko"}
  ];
  private static noExportColumnsIfInRoleMakler: string[] = ["Deckung KH", "Produktlinie"];
  private static noExportColumnsIfInRoleMaklerbetreuer: string[] = [
    "Deckung KH", "Produktlinie", "AZ Beitrag Gesamt", "AZ Beitrag KH", "AZ Beitrag Kasko"
  ];

  private chooseColumnMappingRestrictedTo(onlyColumns: any[], inUserRole: UserRole): Property2ReadableName[] {
    let onlyColumnsAsString: string[] = onlyColumns.map(value => value['header']);
    let columnsNames2Use = AppDatatableKraft.dataMapping2Object.filter(value => onlyColumnsAsString.includes(value.readableName));

    let columnsAdditionallyRestrictedByRole: Property2ReadableName[];
    switch (inUserRole) {
      case UserRole.MAKLER:
        columnsAdditionallyRestrictedByRole = columnsNames2Use.filter(value => !AppDatatableKraft.noExportColumnsIfInRoleMakler.includes(value.readableName));
        break;
      case UserRole.MAKLERBETREUER:
        columnsAdditionallyRestrictedByRole = columnsNames2Use.filter(value => !AppDatatableKraft.noExportColumnsIfInRoleMaklerbetreuer.includes(value.readableName));
        break;
      default:
        columnsAdditionallyRestrictedByRole = columnsNames2Use;
        break;
    }

    return columnsAdditionallyRestrictedByRole;
  }

  private convertData2ObjectForm(inputData: object[]): Vorgang[] {
    let convertedData: Vorgang[] = Array<Vorgang>();

    Object.values(inputData).map(arrayItem => {
      let vorgang: Vorgang = new Vorgang();
      AppDatatableKraft.dataMapping2Object.map(propertyMapping => {
        if (undefined != arrayItem[propertyMapping.readableName]) {
          if (propertyMapping.readableName === "HINWEIS") {
            vorgang[propertyMapping.propertyName] = arrayItem[propertyMapping.readableName].errorMeldung;
          } else {
            vorgang[propertyMapping.propertyName] = arrayItem[propertyMapping.readableName].string;
          }
        }
      });
      convertedData.push(vorgang);
    });

    return convertedData;
  }

  isAuswahlFeld(spalte: string): boolean {
    return this.globals.isAuswahlFeld(spalte); /*
    for (var i:number = 0; i < this.listBoxFelder.length; i++) {
      if (spalte.startsWith(this.listBoxFelder[i]))
        return true;
      else
      if (spalte === this.listBoxFelder[i])
        return true;
    }
    return false; /* */
  }

  isFilterFeld(spalte: string): boolean {
    for (var i: number = 0; i < this.filterFelder.length; i++) {
      if (spalte.startsWith(this.filterFelder[i]))
        return true;
    }
    return false;
  }

  trackVorgangTable(index: number, item: any): number {
    return index;
  } /* */

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      // general values
      let value1 = data1[event.field].string;
      let value2 = data2[event.field].string;
      let result = null;

      // get day, month and year of dd.MM.yyyy Dateformat
      let dateString1 = value1.match(/^(\d{2}).(\d{2}).(\d{4})$/);
      let dateString2 = value2.match(/^(\d{2}).(\d{2}).(\d{4})$/);

      // cast strings to number
      let number1 = Number(value1);
      let number2 = Number(value2);

      const FIELDS_SF = [
        'SFKlasse Haftpflicht',
        'SFKlasse Vollkasko'
      ];

      if (dateString2 || dateString1) {

        // generate Date objects and get their unix timestamps for comparision -> null if no valid date
        value1 = dateString1 ? new Date(dateString1[3], dateString1[2] - 1, dateString1[1]).getTime() : null;
        value2 = dateString2 ? new Date(dateString2[3], dateString2[2] - 1, dateString2[1]).getTime() : null;

        result = value1 == null || value2 == null ? 0 : value1 - value2;

      } else if (number1 || number2) {

        result = this.defaultSort(number1, number2);

      } else if (FIELDS_SF.includes(event.field)) {

        // string manipulation for custom SF Sort -> divide SF from their digits
        let class1 = value1.substring(0, 2);
        let class2 = value2.substring(0, 2);
        let digit1 = value1.substring(2, 5);
        let digit2 = value2.substring(2, 5);
        // if class is SF then sort by numbers
        let isSF = class1 == 'SF' && class2 == 'SF';

        result = this.defaultSort(isSF ? Number(digit1 == '1/2' ? 0.5 : digit1) : class1,  isSF ? Number(digit2 == '1/2' ? 0.5 : digit2) : class2);

      } else {

        result = this.defaultSort(value1, value2);

      }

      return (event.order * result);
    });
  }

  // default sort method
  defaultSort(value1: any, value2: any): number {
    let result;

    if (value1 == null && value2 != null) {
      result = -1;
    } else if (value1 != null && value2 == null) {
      result = 1;
    } else if (value1 == null && value2 == null) {
      result = 0;
    } else if (typeof value1 === 'string' && typeof value2 === 'string') {
      result = value1.localeCompare(value2);
    } else {
      result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
    }
    return result;
  }
}

